import { Component } from '@angular/core';
import {CadastrosGeraisService} from "../../services/cadastros-gerais.service";
import {TipoDocumentoCliente} from "../models/tipo-documento-cliente";
import Swal from "sweetalert2";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-tipo-documento-cliente',
    templateUrl: './tipo-documento-cliente.component.html',
    styleUrl: './tipo-documento-cliente.component.css',
    standalone: false
})
export class TipoDocumentoClienteComponent {
  loading = true;
  public colunas = ['Id', 'Descrição'];
  public linhas: any[] = [];
  listaDocumento: TipoDocumentoCliente[] = [];
  tipoDocumentoCliente = new TipoDocumentoCliente();
  adicionar = false;
  paginaAtual = 1;

  constructor(private cadastrosGeraisService: CadastrosGeraisService,
              private toastr: ToastrService) {
    this.buscarLista();
  }

  public pageChange(event: number){
    this.paginaAtual = event;
  }

  public showModal() {
    this.adicionar = true;
  }

  public fecharModal(){
    this.adicionar = false;
  }

  public salvar(){
    this.loading = true;
    this.cadastrosGeraisService.adicionarTipoDocumentoCliente(this.tipoDocumentoCliente).subscribe(resultado => {
      if(resultado.sucesso){
        this.toastr.success("Tipo de documento do cliente adicionado com sucesso!");
        this.fecharModal();
        this.linhas = [];
        this.buscarLista();
      }
      else{
        this.toastr.error(resultado.errors[0].mensagem);
      }
    }, error => {
      this.toastr.error(error);
    });
    this.loading = false;
  }

  public desativar(id: number){
    this.loading = true;
    Swal.fire({
      title: 'Deseja realmente desativar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#fd7e14',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.cadastrosGeraisService.desativarTipoDocumentoCliente(id).subscribe(resultado => {
          if(resultado.sucesso){
            this.toastr.success("Desativado com sucesso");
            this.buscarLista();
          }
        })
      }
    });
    this.loading = false;
  }

  private buscarLista(): void {
    this.cadastrosGeraisService.selecionarListaTipoDocumentosCliente().subscribe(response => {
      if(response.sucesso)
      {
        this.listaDocumento = [];
        this.listaDocumento = response.dados;
      }
    });
    this.loading = false;
  }
}
